import React from 'react';
import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { DELETE_ACTIVITY, GET_ALL_ACTIVITY } from '../../../graphql';
import client from '../../../ApolloClient';

const { confirm } = Modal;

const deleteConfirm = (id) => {
  confirm({
    title: 'Are you sure you want to delete this activity?',
    icon: <ExclamationCircleOutlined />,
    content: 'Deleting this activity would also delete on the student dashboard',
    onOk: () => client.mutate({
      mutation: DELETE_ACTIVITY,
      variables: { id },
      update: (proxy) => {
        const cached = proxy.readQuery({ query: GET_ALL_ACTIVITY, variables: {} });
        if (!cached) return;
        proxy.writeQuery({
          query: GET_ALL_ACTIVITY,
          variables: {},
          data: { activities: cached.activities.filter(({ id: activityId }) => activityId !== id) },
        });
      },
    }).then(() => {
      message.success('Activity Deleted Successfully');
    }).catch(() => {
      message.error('Could not delete activity');
    }),
    onCancel() {},
  });
};

export default deleteConfirm;
